module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-4.024a15ca.png";